



































































import { defineComponent, toRefs, PropType, ref, computed, watch } from '@vue/composition-api';
import formItemRejectReason from '@/components/common/form-item-reject-reason/index.vue';
import {
  AcoFormData,
  AdgroupFormData,
  CampaignFormData,
  CreateMode,
  FormItem,
  FullNormalFormData,
  NormalCreative,
} from '@tt4b/ttam-enums';
import CreativeGeneralDeeplink from './index';
import { isEmpty } from 'lodash-es';
import {
  useCreativeDeepLinkValidate,
  useStdAdgroupOptimizationGoal,
  useStdCreativeAdgroupIs,
  useStdCreativeIs,
  useCreativeFormStatus,
  useIsNotSupportProductLink,
  getOriginalQuery,
  param2Utm,
  generateCustomParams,
  useUtmUpdateHook,
  useAllowlist,
} from '@tt4b/ttam-hooks';
import { i18n } from '@tt4b/ttam-i18n';
import { MessageBox } from 'byted-vui';
import { RejectReason } from './../../common/form-item-reject-reason/types';
import CreativeWebsiteUrl from '../creative-website-url/index';
import { parseUrl } from 'query-string';

const name = 'ttam-creative-general-deeplink-compose';
export default defineComponent({
  name,
  components: {
    TtamCreativeGeneralDeeplinkSwitch: CreativeGeneralDeeplink.TtamCreativeGeneralDeeplinkSwitch,
    TtamCreativeGeneralDeeplinkInput: CreativeGeneralDeeplink.TtamCreativeGeneralDeeplinkInput,
    TtamCreativeGeneralDeeplinkCheck: CreativeGeneralDeeplink.TtamCreativeGeneralDeeplinkCheck,
    TtamCreativeGeneralDeeplinkPreviewDialog: CreativeGeneralDeeplink.TtamCreativeGeneralDeeplinkPreviewDialog,
    formItemRejectReason,
    TtamCreativeUtmEntry: CreativeWebsiteUrl.TtamCreativeUtmEntry,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({}),
    },
    normalCreativeList: {
      type: Array as PropType<NormalCreative[]>,
      default: () => [],
    },
    normalCreative: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    createMode: {
      type: String as PropType<CreateMode>,
      default: CreateMode.CREATE,
    },
    currentAdgroupIdCreativeList: {
      type: Array as PropType<NormalCreative[]>,
      default: () => [],
    },
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
    isNonDlpInstantPage: {
      type: Boolean,
      default: false,
    },
    rejectReason: {
      type: Array as PropType<RejectReason[]>,
      default: () => [],
    },
    openUrlProp: {
      type: String,
      default: 'openUrl',
    },
    isOpenUrlProp: {
      type: String,
      default: 'isOpenUrl',
    },
  },
  setup(props, { emit }) {
    const {
      adgroupData,
      campaignData,
      creativeData,
      normalCreativeList,
      normalCreative,
      isDisabledCreative,
      createMode,
      openUrlProp,
      isOpenUrlProp,
      currentAdgroupIdCreativeList,
    } = toRefs(props);
    const { isUtmBuilderWhite } = useAllowlist();

    const { isSupportFallback, isSupportCommunityEffectBlock, isStandardAdsWithCatalog } = useStdCreativeAdgroupIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
    });
    const { isOptGoalLPV } = useStdAdgroupOptimizationGoal({
      adgroupFormData: adgroupData,
    });
    const { isProductLink, isSingleVideo } = useStdCreativeIs({
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
      creativeFormData: creativeData,
    });
    const { isShowInstantPage } = useCreativeFormStatus({
      creativeFormData: creativeData,
      adgroupFormData: adgroupData,
      campaignFormData: campaignData,
      normalCreativeData: normalCreative,
      createMode,
    });
    const { websiteDeeplinkValidator } = useCreativeDeepLinkValidate({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      isSupportCommunityEffectBlock,
      isShowInstantPage,
      isProductLink,
    });
    const refDeeplink = ref<FormItem>();
    const shareUtmProps = {
      isOpenUrl: true,
      overrideUrl: true,
      openUrlProp,
    };

    const originalQuery = getOriginalQuery({
      creativeData,
      ...shareUtmProps,
    });

    const { handleUtmUpdate, checkEmitUtm, hasAppliedUtm, handleAppliedUtm, handleBuilderUtm } = useUtmUpdateHook({
      formData: creativeData,
      emit,
      isVsa: true,
      originalQuery,
      setFormData: () => () => ({}),
      ...shareUtmProps,
    });

    const _openUrl = computed({
      get: () => creativeData.value[openUrlProp.value],
      set: (newV: string) => {
        handleUtmUpdate(newV);
        checkEmitUtm(newV);
        emit('open-url-change', newV);
      },
    });
    const isOpenUrlEmpty = computed(() => isEmpty(_openUrl.value));

    const _isOpenUrl = computed({
      get: () => Boolean(creativeData.value[isOpenUrlProp.value]),
      set: (val: boolean) => {
        if (isSupportFallback.value && normalCreativeList.value.length > 1) {
          const title = val
            ? i18n.t('module_ad_deeplink_message_confirm_desc')
            : i18n.t('module_ad_deeplink_message_cancel_desc');
          MessageBox.confirm(title, i18n.t('module_ad_deeplink_message_confirm_title')).then(() => {
            emit('is-open-url-change', val ? 1 : 0);
          });
        } else {
          emit('is-open-url-change', val ? 1 : 0);
        }
        emit('open-url-utms-change', []);
      },
    });

    const handleApplyUtm = (newParams: string): void => {
      const hasUrlScene = _openUrl.value.length > 0;
      if (!hasAppliedUtm.value) {
        handleAppliedUtm(true);
      }
      if (hasUrlScene) {
        const { url } = parseUrl(_openUrl.value);
        handleBuilderUtm(true);
        const originCustomParams = generateCustomParams(originalQuery.value);
        _openUrl.value = originCustomParams
          ? `${url}?${originCustomParams}&${newParams.slice(1)}`
          : `${url}${newParams}`;
      } else {
        const newUtms = param2Utm(newParams);
        emit('open-url-utms-change', newUtms);
      }
    };

    const previewDialogVisible = ref(false);
    const onCheckButtonClick = () => {
      previewDialogVisible.value = true;
    };
    const onPreviewModalClose = () => {
      previewDialogVisible.value = false;
    };

    const { disabledDeeplinkAndFallback: disabledDeeplinkSwitch } = CreativeGeneralDeeplink.usePropsFallback({
      adgroupData,
      campaignData,
      creativeData,
      createMode,
      currentAdgroupIdCreativeList,
      isDisabledCreative,
    });
    const disabledDeeplinkInput = computed(() => isDisabledCreative.value || isOptGoalLPV.value);

    const deeplinkInputVisible = computed(() => _isOpenUrl.value && !isProductLink.value);
    const checkButtonVisible = computed(() => deeplinkInputVisible.value && !isOpenUrlEmpty.value);
    const { isNotSupportProductLink: onlySupportCustomLink } = useIsNotSupportProductLink({
      creativeData,
      adgroupData,
    });

    // 开关值变化的时候清空表单校验状态
    // watch(_isOpenUrl, () => {
    //   refDeeplink.value?.clearValidate();
    // });

    return {
      name,
      refDeeplink,
      _openUrl,
      _isOpenUrl,
      isSingleVideo,
      previewDialogVisible,
      deeplinkInputVisible,
      checkButtonVisible,
      disabledDeeplinkSwitch,
      disabledDeeplinkInput,
      websiteDeeplinkValidator,
      originalQuery,
      onCheckButtonClick,
      onPreviewModalClose,
      // onChangeOpenUrl,
      handleApplyUtm,
      isUtmBuilderWhite,
      onlySupportCustomLink,
      isStandardAdsWithCatalog,
    };
  },
});
